const map = {
	"./_custom_tour_of_britain": [
		2456,
		[
			2456
		]
	],
	"./_custom_tour_of_britain.ts": [
		2456,
		[
			2456
		]
	],
	"./_custom_worldrowing": [
		1039,
		[
			5120,
			1039
		]
	],
	"./_custom_worldrowing.ts": [
		1039,
		[
			5120,
			1039
		]
	],
	"./_custom_worldrowing_flags": [
		3093,
		[
			5120,
			3093
		]
	],
	"./_custom_worldrowing_flags.ts": [
		3093,
		[
			5120,
			3093
		]
	],
	"./american_football": [
		3377,
		[
			3377
		]
	],
	"./american_football.ts": [
		3377,
		[
			3377
		]
	],
	"./badminton": [
		2277,
		[
			2277
		]
	],
	"./badminton.ts": [
		2277,
		[
			2277
		]
	],
	"./badminton_team": [
		5101,
		[
			5101
		]
	],
	"./badminton_team.ts": [
		5101,
		[
			5101
		]
	],
	"./baseball": [
		3333,
		[
			3333
		]
	],
	"./baseball.ts": [
		3333,
		[
			3333
		]
	],
	"./basketball": [
		6309,
		[
			6309,
			4827
		]
	],
	"./basketball.ts": [
		6309,
		[
			6309,
			4827
		]
	],
	"./beach_volleyball": [
		4387,
		[
			4387
		]
	],
	"./beach_volleyball.ts": [
		4387,
		[
			4387
		]
	],
	"./cycling": [
		3272,
		[
			3272
		]
	],
	"./cycling.ts": [
		3272,
		[
			3272
		]
	],
	"./cyclocross": [
		505,
		[
			505,
			9398
		]
	],
	"./cyclocross.ts": [
		505,
		[
			505,
			9398
		]
	],
	"./darts": [
		9041,
		[
			9041
		]
	],
	"./darts.ts": [
		9041,
		[
			9041
		]
	],
	"./fieldhockey": [
		9697,
		[
			9697,
			7208
		]
	],
	"./fieldhockey.ts": [
		9697,
		[
			9697,
			7208
		]
	],
	"./floorball": [
		9405,
		[
			9405
		]
	],
	"./floorball.ts": [
		9405,
		[
			9405
		]
	],
	"./futsal": [
		5491,
		[
			5491
		]
	],
	"./futsal.ts": [
		5491,
		[
			5491
		]
	],
	"./gaelic_sports": [
		9172,
		[
			9172,
			152
		]
	],
	"./gaelic_sports.ts": [
		9172,
		[
			9172,
			152
		]
	],
	"./handball": [
		3696,
		[
			3696,
			65
		]
	],
	"./handball.ts": [
		3696,
		[
			3696,
			65
		]
	],
	"./icehockey": [
		4812,
		[
			4812,
			2446
		]
	],
	"./icehockey.ts": [
		4812,
		[
			4812,
			2446
		]
	],
	"./motoball": [
		2972,
		[
			2972,
			7771
		]
	],
	"./motoball.ts": [
		2972,
		[
			2972,
			7771
		]
	],
	"./motorsports": [
		9850,
		[
			9850
		]
	],
	"./motorsports.ts": [
		9850,
		[
			9850
		]
	],
	"./news": [
		3726,
		[
			3726
		]
	],
	"./news.ts": [
		3726,
		[
			3726
		]
	],
	"./rugby_union": [
		9039,
		[
			9039,
			5390
		]
	],
	"./rugby_union.ts": [
		9039,
		[
			9039,
			5390
		]
	],
	"./ski_alpine": [
		494,
		[
			494
		]
	],
	"./ski_alpine.ts": [
		494,
		[
			494
		]
	],
	"./soccer": [
		2654,
		[
			2654,
			8506
		]
	],
	"./soccer.ts": [
		2654,
		[
			2654,
			8506
		]
	],
	"./softball": [
		7094,
		[
			7094
		]
	],
	"./softball.ts": [
		7094,
		[
			7094
		]
	],
	"./tabletennis": [
		2572,
		[
			2572
		]
	],
	"./tabletennis.ts": [
		2572,
		[
			2572
		]
	],
	"./tennis": [
		6514,
		[
			6514
		]
	],
	"./tennis.ts": [
		6514,
		[
			6514
		]
	],
	"./volleyball": [
		3434,
		[
			3434
		]
	],
	"./volleyball.ts": [
		3434,
		[
			3434
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9717;
module.exports = webpackAsyncContext;